import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[hsl(120_38%_8%)]">
        <Loader2 className="w-8 h-8 animate-spin text-[hsl(16_57%_50%)]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  return children;
}
